import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

import logoIcon from '../asset/img/common/logo_korean.svg';
import menuArrowRightIcon from '../asset/img/common/menu_arrow_right_icon.svg';
import menuArrowTopIcon from '../asset/img/common/menu_arrow_top_icon.svg';
import menuArrowRightPrimaryIcon from '../asset/img/common/menu_arrow_right_primary_icon.svg';
import menuArrowTopPrimaryIcon from '../asset/img/common/menu_arrow_top_primary_icon.svg';
import submenuIcon from '../asset/img/common/submenu_icon.svg';
import submenuIconPrimary from '../asset/img/common/submenu_primary_icon.svg';

import SlideLeftDialog from './common/SlideLeftDialog';
import { menuItems } from '../common/data';
import { useLocation, useNavigate } from 'react-router-dom';

const shouldForwardProp = prop => !['isSelected', 'isFirst', 'isOpen'].includes(prop);

const MenuWrapper = styled.div`
  padding: 10px 24px;
  position: absolute;
  top: 64px;
  width: 100%;
  overflow-y: scroll;
  height: calc(100% - 64px);
`;

const LogoWrapper = styled.div`
  padding: 0px 16px 0px 24px;
  position: absolute;
  align-items: center;
  display: flex;
  border-bottom: 1px solid var(--GrayScale-400);
  width: 100%;
  left: 0;
  height: 64px;
`;

const MenuItem = styled.div.withConfig({ shouldForwardProp })`
  display: flex;
  padding: 15px;
  align-items: center;
  gap: 10px;
  width: 100%;
  cursor: pointer;
  border-radius: 5px;
  justify-content: space-between;
  ${({ isSelected }) =>
    isSelected &&
    `
    color: var(--Primary-600);
    background: var(--Primary-50);
  `}
`;

const SubMenuItem = styled(MenuItem).withConfig({ shouldForwardProp })`
  padding-left: 30px;
  ${({ isSelected }) =>
    isSelected &&
    `
    color: var(--Primary-600);
    background: var(--Primary-50);
  `}
  display: flex;
  padding: 12px 15px 12px 35px;
  align-items: center;
  width: calc(100% - 24px);
  margin-right: 15px;
  justify-content: flex-start;
  gap: 10px;

  ${({ isFirst }) =>
    isFirst &&
    `
    margin-top: 8px;
  `}
`;

const MenuArrowIcon = styled.img``;

const MenuArrowTopIcon = styled.img.withConfig({ shouldForwardProp })`
  transition: transform 0.3s ease;
  transform: ${({ isOpen }) => (isOpen ? 'rotate(0deg)' : 'rotate(180deg)')};
`;

const MenuSlide = ({ isOpen, onClose }) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { t } = useTranslation('common');
  const menuList = menuItems(t);
  const [subMenuOpen, setSubMenuOpen] = useState(false);
  const [selectedMenu, setSelectedMenu] = useState(null);

  useEffect(() => {
    if (isOpen) {
      console.log('pathname >>', pathname);
      setSelectedMenu(pathname);
      if (pathname.startsWith('/deductions')) {
        setSubMenuOpen(true);
      }
    }
  }, [isOpen]);

  const handleMenuClick = menu => {
    // 공제항목 메뉴 클릭 시 서브메뉴 토글
    if (menu.path === '/subItem') {
      setSubMenuOpen(!subMenuOpen);
      return;
    }
    setSelectedMenu(menu.path);
    navigate(menu.path);
  };

  const renderMenuItem = (menu, index) => {
    const isMenuSelected = menu.path === '/subItem' ? subMenuOpen : selectedMenu === menu.path;

    if (menu.isSubItem) {
      return subMenuOpen ? (
        <SubMenuItem
          key={index}
          className="body1Bold"
          isSelected={selectedMenu === menu.path}
          onClick={() => handleMenuClick(menu)}
          isFirst={menu.isFirst}>
          <img
            src={selectedMenu === menu.path ? submenuIconPrimary : submenuIcon}
            alt={menu.label}
          />
          {menu.label}
        </SubMenuItem>
      ) : null;
    }
    return (
      <MenuItem
        key={index}
        className="body1Bold"
        isSelected={isMenuSelected}
        onClick={() => handleMenuClick(menu)}>
        {menu.label}
        {menu.path === '/subItem' ? (
          <MenuArrowTopIcon
            src={isMenuSelected ? menuArrowTopPrimaryIcon : menuArrowTopIcon}
            alt={menu.label}
            isOpen={subMenuOpen}
            isSelected={isMenuSelected || selectedMenu?.startsWith('/deductions')}
          />
        ) : (
          <img
            src={isMenuSelected ? menuArrowRightPrimaryIcon : menuArrowRightIcon}
            alt={menu.label}
          />
        )}
      </MenuItem>
    );
  };

  return (
    <SlideLeftDialog isOpen={isOpen} onClose={onClose} style={{ padding: '0px' }}>
      <LogoWrapper onClick={() => navigate('/')}>
        <img src={logoIcon} alt="월급날로고 홈으로" />
      </LogoWrapper>
      <MenuWrapper className="noneScroll">
        {menuList.map((menu, index) => renderMenuItem(menu, index))}
      </MenuWrapper>
    </SlideLeftDialog>
  );
};

export default MenuSlide;
